import React from 'react';
import { Label } from "reactstrap";
import { FieldProps } from 'formik'

const CheckBox:React.FC<FieldProps & {
  id: string;
  label: string;
  value: string;
  alphabet?: any;
  show_quiz: boolean;
  bgColor?: string;
}> = ({
  field: { name, value, onBlur },
  form: { setFieldValue },
  id,
  label,
  value: radioValue,
  alphabet,
  show_quiz,
  ...props
}) => {
  return (
    <div className="formik-radio">
      <Label className={`label-color ${props.bgColor}`} htmlFor={id}>
        <input
          name={name}
          id={id}
          type="checkbox"
          checked={value}
          onChange={e => setFieldValue(name, e.target.checked)}
          onBlur={onBlur}
          className="radio-button"
          {...props}
        />
        {alphabet && <span className="alpha">{alphabet}</span>}
        {label}
        {
          show_quiz &&
          <span className="radio-btn"></span>
        }
      </Label>
    </div>
  );
};

export default CheckBox;